module.exports = __webpack_public_path__ + "static/kbusiness0-2639fbeaae71e2a117a1b70dbd493f4f.png";